import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createReferralReportSlice = (set, get) => ({
    referral: {
        loading: false,
        data: []
    },
    getReferralReport: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ referral: { ...state.referral, loading: true } }));
        try {
            const res = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/referral-report/user/${param}`,
                headers: { token },
            });
            set(state => ({ referral: { loading: false, data: res.data } }));
        } catch (error) {
            set(state => ({ referral: { ...state.referral, loading: false } }));
        }
    }
});
